/**
 * Default: Modules > Solr > Results
 *
 * @copyright 2025 i-fabrik GmbH
 * @author Tobias Garz
 */

import SelectorEngine from '../../../../shared/dom/selector-engine';
import EventHandler from '../../../../shared/dom/event-handler';

// -------
// Private
// -------

const NAME = 'solr';

const initAutoLinks = () => {
	const COLLECTION = SelectorEngine.find(`.${NAME}-results [data-auto-link]`);

	if(!COLLECTION.length) return;

	for(let element of COLLECTION) {
		EventHandler.on(element, 'change', () => {
			location.href = element.value;
		});
	}
};

const initAutoSubmits = () => {
	const COLLECTION = SelectorEngine.find(`.${NAME}-results [data-auto-submit]`);

	if(!COLLECTION.length) return;

	for(let element of COLLECTION) {
		EventHandler.on(element, 'change', () => {
			let form = SelectorEngine.parents(element, '.form');

			if(form) {
				form[0].submit();
			}
		});
	}
};

// -------
// Private
// -------

const init = () => {
	initAutoSubmits();
	initAutoLinks();
};

// Excute
init();